import React from "react";

// Shared "card thumbnail" upload field for every admin create/edit form
// that has one (ArticleFormPage.js, TopicFormPage.js, IssueTopicFormPage.js):
// a file input, a preview of whatever image is already saved, and a
// button to clear it. Lives here instead of being copy-pasted three times
// since all three need the exact same remove/replace behavior, not just
// the same look.
//
// - `imageUrl`: the existing saved image's full URL, or "" if none.
// - `file`: a newly chosen File not yet submitted, or null.
// - `removed`: true if the admin clicked "remove" and hasn't picked a
//   new file since.
// - `onFileChange(file)` / `onRemove()`: the parent form owns all three
//   pieces of state (file/removed/existing path) since it needs them at
//   submit time to build the right FormData.
function AdminImageField({ label, imageUrl, file, removed, onFileChange, onRemove }) {
  const showExistingPreview = Boolean(imageUrl) && !file && !removed;

  return (
    <div className="auth-field">
      <label htmlFor="image">{label}</label>

      {showExistingPreview && (
        <div className="admin-image-preview-row">
          <img src={imageUrl} alt="" className="admin-image-preview" />
          <button type="button" className="admin-image-remove" onClick={onRemove}>
            حذف تصویر
          </button>
        </div>
      )}

      <input
        id="image"
        type="file"
        accept="image/png, image/jpeg, image/webp"
        onChange={(e) => onFileChange(e.target.files[0] || null)}
      />
    </div>
  );
}

export default AdminImageField;
